import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=4f552051&scoped=true"
import script from "./inquiry.vue?vue&type=script&lang=js"
export * from "./inquiry.vue?vue&type=script&lang=js"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=4f552051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f552051",
  null
  
)

export default component.exports